import { render, staticRenderFns } from "./EditRoadTaxModal.vue?vue&type=template&id=c1a08c10&"
import script from "./EditRoadTaxModal.vue?vue&type=script&lang=js&"
export * from "./EditRoadTaxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports